import React, { useEffect, useMemo, useState } from 'react';
import styles from './bottom-footer.module.css';
import { BottomFooterRes } from '../../typescript/response';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { appendLocaleToOwnSite } from '../../helper/utils';

export default function BottomFooter({ bottomFooter }: { bottomFooter: BottomFooterRes }) {
  const [isMobile, setIsMobile] = useState(false);
  const { locale } = useRouter();

  const getCurrentForCopyright = useMemo(() => {
    const textYear = '{year}';
    const currentYear = new Date().getFullYear();
    return bottomFooter?.copyright && bottomFooter?.copyright?.includes(textYear)
      ? bottomFooter?.copyright?.replace(textYear, currentYear.toString())
      : bottomFooter?.copyright;
  }, [bottomFooter?.copyright]);

  const generateSocailLogoAndCopyright = useMemo(() => {
    return (
      <>
        {bottomFooter?.message && (
          <div className={styles.legalInfo} {...(bottomFooter.$?.message as {})}>
            <div className={styles.message1}>{bottomFooter.message}</div>
          </div>
        )}
        <div className={styles.footerBranding}>
          {bottomFooter.brand_mark_list &&
            bottomFooter.brand_mark_list.length > 0 &&
            bottomFooter.brand_mark_list.map((item, index) => (
              <a
                {...(item.link.$?.href as {})}
                href={appendLocaleToOwnSite(item?.link?.href, locale)}
                target="_blank"
                className={styles.brandmarkIcon}
                rel="noopener noreferrer"
                key={index}
              >
                <Image
                  {...(item.logo.$?.url as {})}
                  src={`${item.logo.url}?width=24&height=24&auto=webp&fit=smart`}
                  alt={item.logo.description || item.link.title}
                  width={24}
                  height={24}
                  loading="lazy"
                  className={styles.socialIcon}
                />
              </a>
            ))}
        </div>
      </>
    );
  }, [bottomFooter, locale]);

  useEffect(() => {
    if (window?.innerWidth < 800) {
      setIsMobile(true);
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={[styles.bottomFooter].join(' ')}>
        <div className={styles.footerMessage}>
          <div className={styles.message} {...(bottomFooter.$?.copyright as {})}>
            {getCurrentForCopyright}
          </div>
        </div>
        {isMobile ? (
          generateSocailLogoAndCopyright
        ) : (
          <div className={styles['bottomFooter-right']}>{generateSocailLogoAndCopyright}</div>
        )}
      </div>
    </div>
  );
}
